/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The new statement of one problem and the example calls to add to it.
 * @export
 * @interface StatementUpdate
 */
export interface StatementUpdate {
    /**
     * 
     * @type {string}
     * @memberof StatementUpdate
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof StatementUpdate
     */
    statement_html: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatementUpdate
     */
    examples?: Array<string>;
}

/**
 * Check if a given object implements the StatementUpdate interface.
 */
export function instanceOfStatementUpdate(value: object): value is StatementUpdate {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('statement_html' in value) || value['statement_html'] === undefined) return false;
    return true;
}

export function StatementUpdateFromJSON(json: any): StatementUpdate {
    return StatementUpdateFromJSONTyped(json, false);
}

export function StatementUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'statement_html': json['statement_html'],
        'examples': json['examples'] == null ? undefined : json['examples'],
    };
}

export function StatementUpdateToJSON(json: any): StatementUpdate {
    return StatementUpdateToJSONTyped(json, false);
}

export function StatementUpdateToJSONTyped(value?: StatementUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'statement_html': value['statement_html'],
        'examples': value['examples'],
    };
}

